import { render, staticRenderFns } from "./MusicList.vue?vue&type=template&id=2b1fac94&scoped=true&"
import script from "./MusicList.vue?vue&type=script&lang=js&"
export * from "./MusicList.vue?vue&type=script&lang=js&"
import style0 from "./MusicList.vue?vue&type=style&index=0&id=2b1fac94&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1fac94",
  null
  
)

export default component.exports